import * as core from '../../../../../../../core'
import * as employeePlanning from '../employee-planning'

export const RESOURCE = {
  payload: {
    alias: 'employee-org',
    appAlias: employeePlanning.RESOURCE.payload.alias,
    description:
      "Examine the organization's employee structure through an interactive chart.",
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Organization Chart',
    page: { alias: 'employee-org' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
